import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { URL_SERVICIOS } from '../config/config';
import { ErrorsService } from './errors.service';
export type BgAction = 'update' | 'delete';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    public http: HttpClient,
    public router: Router,
    public _errors: ErrorsService,
  ) {

  }

  async postListarCustomer({ main = null, is_bulk_type = false, products_list = false }) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    let params = {
      main,
      is_bulk_type,
      products_list
    }

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarCustomer', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

 async postCrearCustomer(
  cus_name,
  cus_url,
  cus_phone,
  cus_image: File,
  cus_can_pay,
  cus_can_snabb,
  cus_can_show_agreement,
  cus_can_ivirtual,
  cus_can_examedi,
  cus_can_yapp,
  cus_can_convenio_particular,
  cus_can_subscription_planilla,
  cus_can_subscription_mp,
  cus_can_subscription_wp,
  cus_can_subscription_vp,
  cus_can_subscription_card,
  cus_can_validate_autentika,
  cus_url_wsp,
  link_centro_ayuda,
  link_volver_sitio,
  cus_mail_contact
) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        // 'Content-Type': 'application/json'
      })
    };

    const fd = new FormData();
    fd.append('file', cus_image, cus_image.name);
    fd.append('cus_name', cus_name);

    if (cus_url) {
      fd.append('cus_url', cus_url);
    }

    if (cus_phone) {
      fd.append('cus_phone', cus_phone);
    }

    if (cus_can_pay) {
      fd.append('cus_can_pay', 'true');
    }

    if (cus_can_snabb) {
      fd.append('cus_can_snabb', 'true');
    }

    if (cus_can_show_agreement) {
      fd.append('cus_can_show_agreement', 'true');
    }

    if (cus_can_ivirtual) {
      fd.append('cus_can_ivirtual', 'true');
    }

    if (cus_can_examedi) {
      fd.append('cus_can_examedi', 'true');
    }
    if (cus_can_yapp) {
      fd.append('cus_can_yapp', 'true');
    }
    if (cus_can_convenio_particular) {
      fd.append('cus_can_convenio_particular', 'true');
    }
    if (cus_can_subscription_planilla) {
      fd.append('cus_can_subscription_planilla', 'true');
    }
    if (cus_can_subscription_mp) {
      fd.append('cus_can_subscription_mp', 'true');
    }
    if (cus_can_subscription_wp) {
      fd.append('cus_can_subscription_wp', 'true');
    }
    if (cus_can_subscription_vp) {
      fd.append('cus_can_subscription_vp', 'true');
    }
    if (cus_can_subscription_card) {
      fd.append('cus_can_subscription_card', 'true');
    }
    if (cus_can_validate_autentika) {
      fd.append('cus_can_validate_autentika', 'true');
    }
    if (cus_url_wsp) {
      fd.append('cus_url_wsp', cus_url_wsp);
    }

    if (link_centro_ayuda) {
      fd.append('link_centro_ayuda', link_centro_ayuda);
    }

    if (link_volver_sitio) {
      fd.append('link_volver_sitio', link_volver_sitio);
    }
    if (cus_mail_contact) {
      fd.append('cus_mail_contact', cus_mail_contact);
    }

    if (cus_can_yapp) {
      fd.append('cus_can_yapp', 'true');
    }

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postCrearCustomer', fd, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async postModificarCustomer(data: any) {
    const fd = new FormData();

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: sessionStorage.getItem('token') || ''
      })
    };

    fd.append('cus_id', String(data.cus_id));
    fd.append('cus_name', data.cus_name || '');

    fd.append('cus_url', data.cus_url || '');
    fd.append('cus_phone', data.cus_phone || '');
    fd.append('cus_url_wsp', data.cus_url_wsp || '');
    fd.append('link_centro_ayuda', data.link_centro_ayuda || '');
    fd.append('link_volver_sitio', data.link_volver_sitio || '');
    fd.append('cus_mail_contact', data.cus_mail_contact || '');

    if (data.cus_image instanceof File) {
      fd.append('file', data.cus_image, data.cus_image.name);
    }

    fd.append('cus_can_pay', data.cus_can_pay ? 'true' : 'false');
  fd.append('cus_can_snabb', data.cus_can_snabb ? 'true' : 'false');
  fd.append('cus_can_show_agreement', data.cus_can_show_agreement ? 'true' : 'false');
  fd.append('cus_can_ivirtual', data.cus_can_ivirtual ? 'true' : 'false');
  fd.append('cus_can_examedi', data.cus_can_examedi ? 'true' : 'false');
  fd.append('cus_can_yapp', data.cus_can_yapp ? 'true' : 'false');
  fd.append('cus_can_convenio_particular', data.cus_can_convenio_particular ? 'true' : 'false');
  fd.append('cus_can_subscription_planilla', data.cus_can_subscription_planilla ? 'true' : 'false');
  fd.append('cus_can_subscription_mp', data.cus_can_subscription_mp ? 'true' : 'false');
  fd.append('cus_can_subscription_wp', data.cus_can_subscription_wp ? 'true' : 'false');
  fd.append('cus_can_subscription_vp', data.cus_can_subscription_vp ? 'true' : 'false');
  fd.append('cus_can_subscription_card', data.cus_can_subscription_card ? 'true' : 'false');
  fd.append('cus_can_validate_autentika', data.cus_can_validate_autentika ? 'true' : 'false');

    return await this.http
      .post(URL_SERVICIOS + '/postModificarCustomer', fd, httpOptions)
      .toPromise();
  }



  async postBorrarCustomer(cus_id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    let params = {
      cus_id
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postBorrarCustomer', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async postListarCBenefits() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarCBenefits', JSON.stringify({}), httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async postEliminarCBenefits(cus_ben_id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    let params = {
      cus_ben_id
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postEliminarCBenefits', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async postCrearCBenefits(benefit: any) {

  const httpOptions = {
    headers: new HttpHeaders({
      'authorization': sessionStorage.getItem('token'),
    })
  };

  const fd = new FormData();


  // =========================================================
  // ID PLAN - SOLO EDICIÓN
  // =========================================================

  if (benefit.cus_ben_id) {
    fd.append(
      'cus_ben_id',
      String(benefit.cus_ben_id)
    );
  }


  // =========================================================
  // LOGO
  // =========================================================

  if (
    benefit.cus_ben_image &&
    benefit.cus_ben_image.name
  ) {

    fd.append(
      'logo',
      benefit.cus_ben_image,
      benefit.cus_ben_image.name
    );
  }


  // =========================================================
  // MEDIA
  // =========================================================

  /*
   * En edición solamente interesa subir los medios nuevos.
   * Los antiguos ya están guardados.
   */
  const media_array =
    benefit.cus_ben_id
      ? (
        Array.isArray(benefit.new_cus_ben_media)
          ? benefit.new_cus_ben_media
          : []
      )
      : (
        Array.isArray(benefit.cus_ben_media)
          ? benefit.cus_ben_media
          : []
      );


  for (
    let index = 0;
    index < media_array.length;
    index++
  ) {

    const element =
      media_array[index];

    if (
      element &&
      element.name
    ) {

      fd.append(
        'media' + index,
        element,
        element.name
      );

    }

  }


  // =========================================================
  // ESPECIALIDADES
  // =========================================================

  const currentSpecialities =
    Array.isArray(
      benefit.cus_ben_specialities
    )
      ? benefit.cus_ben_specialities
      : [];


  const newSpecialities =
    Array.isArray(
      benefit.new_cus_ben_specialities
    )
      ? benefit.new_cus_ben_specialities
      : [];


  let specialities_array: any[] = [];


  /*
   * CREACIÓN:
   *
   * cus_ben_specialities contiene todas las especialidades
   * agregadas al plan.
   */
  if (!benefit.cus_ben_id) {

    specialities_array = [
      ...currentSpecialities
    ];

  } else {

    /*
     * EDICIÓN:
     *
     * Enviamos:
     *
     * 1. Especialidades existentes
     *    -> pueden traer un spe_order modificado.
     *
     * 2. Especialidades nuevas
     *    -> agregadas durante la edición.
     *
     * NO se hace sort().
     */
    specialities_array = [
      ...currentSpecialities,
      ...newSpecialities
    ];

  }


  /*
   * Nos aseguramos de enviar exclusivamente:
   *
   * spe_order
   *
   * y no:
   *
   * order
   * cus_ben_det_order
   */
  specialities_array =
    specialities_array.map(
      (spe: any) => {

        const {
          order,
          cus_ben_det_order,
          ...speciality
        } = spe;


        const speOrderValue =
          spe?.cus_ben_spe_order ??
          order ??
          cus_ben_det_order ??
          null;


        return {
          ...speciality,

          cus_ben_spe_order:
            speOrderValue === null ||
            speOrderValue === undefined ||
            speOrderValue === ''
              ? null
              : Number(speOrderValue)
        };

      }
    );


  console.log(
    'Especialidades enviadas:',
    specialities_array
  );


  fd.append(
    'cus_ben_specialities',
    JSON.stringify(
      specialities_array
    )
  );


  // =========================================================
  // INFORMACIÓN GENERAL
  // =========================================================

  fd.append(
    'cus_ben_name',
    benefit.cus_ben_name || ''
  );


  fd.append(
    'cus_ben_cus_id',
    String(
      benefit.cus_ben_cus_id || ''
    )
  );


  fd.append(
    'cus_ben_cus_ben_typ_id',
    String(
      benefit.cus_ben_cus_ben_typ_id || ''
    )
  );


 fd.append(
  'cus_ben_description',
  benefit.cus_ben_description || ''
);


  fd.append(
    'cus_ben_particular',
    String(
      benefit.cus_ben_particular
    )
  );


  // =========================================================
  // N° BENEFICIARIOS
  // =========================================================

  if (
    benefit.cus_ben_qty_beneficiaries !== null &&
    benefit.cus_ben_qty_beneficiaries !== undefined &&
    benefit.cus_ben_qty_beneficiaries !== ''
  ) {

    fd.append(
      'cus_ben_qty_beneficiaries',
      String(
        benefit.cus_ben_qty_beneficiaries
      )
    );

  }


  // =========================================================
  // CÓDIGO
  // =========================================================

  if (benefit.cus_ben_code) {

    fd.append(
      'cus_ben_code',
      benefit.cus_ben_code
    );

  }


  // =========================================================
  // TELÉFONO
  // =========================================================

  if (benefit.cus_ben_phone) {

    fd.append(
      'cus_ben_phone',
      benefit.cus_ben_phone
    );

  }


  // =========================================================
  // EMAIL
  // =========================================================

  if (benefit.cus_ben_mail_contact) {

    fd.append(
      'cus_ben_mail_contact',
      benefit.cus_ben_mail_contact
    );

  }


// =========================================================
// TEXTO BIENVENIDA
// =========================================================

fd.append(
  'cus_ben_text_welcome',
  benefit.cus_ben_text_welcome || ''
);
  // =========================================================
// TEXTO CONSIDERACIONES
// =========================================================

fd.append(
  'cus_ben_text_consideraciones',
  benefit.cus_ben_text_consideraciones || ''
);


  // =========================================================
  // SUSCRIPCIÓN
  // =========================================================

  if (
    benefit.cus_ben_is_suscription !== undefined &&
    benefit.cus_ben_is_suscription !== null
  ) {

    fd.append(
      'cus_ben_is_suscription',
      String(
        benefit.cus_ben_is_suscription
      )
    );

  }


  // =========================================================
  // BASE INFORMADA
  // =========================================================

  if (
    benefit.cus_ben_base_informada !== undefined &&
    benefit.cus_ben_base_informada !== null
  ) {

    fd.append(
      'cus_ben_base_informada',
      String(
        benefit.cus_ben_base_informada
      )
    );

  }


  // =========================================================
  // FECHA FACTURACIÓN
  // =========================================================

  if (benefit.cus_ben_fecha_facturacion) {

    fd.append(
      'cus_ben_fecha_facturacion',
      benefit.cus_ben_fecha_facturacion
    );

  }


  // =========================================================
  // PRECIOS
  // =========================================================

  if (
    benefit.cus_ben_price_titular !== undefined &&
    benefit.cus_ben_price_titular !== null &&
    benefit.cus_ben_price_titular !== ''
  ) {

    fd.append(
      'cus_ben_price_titular',
      String(
        benefit.cus_ben_price_titular
      )
    );

  }


  if (
    benefit.cus_ben_price_carga1 !== undefined &&
    benefit.cus_ben_price_carga1 !== null &&
    benefit.cus_ben_price_carga1 !== ''
  ) {

    fd.append(
      'cus_ben_price_carga1',
      String(
        benefit.cus_ben_price_carga1
      )
    );

  }


  if (
    benefit.cus_ben_price_carga2 !== undefined &&
    benefit.cus_ben_price_carga2 !== null &&
    benefit.cus_ben_price_carga2 !== ''
  ) {

    fd.append(
      'cus_ben_price_carga2',
      String(
        benefit.cus_ben_price_carga2
      )
    );

  }
  if (benefit.cus_ben_free_days !== undefined && benefit.cus_ben_free_days !== null && benefit.cus_ben_free_days !== '') {
    fd.append(
      'cus_ben_free_days',
      String(benefit.cus_ben_free_days)
    );
  }


  // =========================================================
  // ORDEN DEL PLAN
  // =========================================================

  if (
    benefit.cus_ben_order !== undefined &&
    benefit.cus_ben_order !== null &&
    benefit.cus_ben_order !== ''
  ) {

    fd.append(
      'cus_ben_order',
      String(
        benefit.cus_ben_order
      )
    );

  }


  // =========================================================
  // HORARIO HÁBIL
  // =========================================================

  if (
    benefit.cus_ben_horario_habil !== undefined &&
    benefit.cus_ben_horario_habil !== null
  ) {

    fd.append(
      'cus_ben_horario_habil',
      String(
        benefit.cus_ben_horario_habil
      )
    );

  }


  // =========================================================
  // HORARIO NO HÁBIL
  // =========================================================

  if (
    benefit.cus_ben_horario_no_habil !== undefined &&
    benefit.cus_ben_horario_no_habil !== null
  ) {

    fd.append(
      'cus_ben_horario_no_habil',
      String(
        benefit.cus_ben_horario_no_habil
      )
    );

  }


  // =========================================================
  // DEBUG FORM DATA
  // =========================================================

  console.log(
    '===== postCrearCBenefits FormData ====='
  );

  fd.forEach(
    (value: any, key: string) => {

      console.log(
        key,
        value
      );

    }
  );


  // =========================================================
  // REQUEST
  // =========================================================

  try {

    const data =
      await this.http
        .post(
          URL_SERVICIOS +
          '/postCrearCBenefits',
          fd,
          httpOptions
        )
        .toPromise();


    return data;

  } catch (error) {

    throw error;

  }

}

  async loadBulkFile(file_data, bulk_data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    let params = {
      file_data,
      bulk_data,
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/loadBulkFile', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async deleteMediaRoomLobby({ med_roo_lob_id }) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    let params = {
      med_roo_lob_id
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/deleteMediaRoomLobby', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async deleteSubSpecialityDetail({ cus_ben_det_id }) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    let params = {
      cus_ben_det_id
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/deleteSubSpecialityDetail', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async deleteProduct({ cus_ben_pro_id }) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    let params = {
      cus_ben_pro_id
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/deleteProduct', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async insertProduct(params) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/insertProduct', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async updateColorsCustomer(params) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        // 'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postUpdateColorsCustomer', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  async getListCustomer() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        // 'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getListCustomers', {}, httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
    }
  }

  /** Imagen Customer profile Background  */
  async uploadBackgroundProfileImage(id: number, enabled: boolean, perfil: string, file: File, action: BgAction): Promise<any> {

    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        // 'Content-Type': 'application/json'
      })
    };

    const formData = new FormData();
    formData.append('enabled', String(enabled));
    formData.append('perfil', perfil);
    formData.append('action', action); // ✅ NUEVO

    // ✅ Solo adjunta archivo si existe (update con nueva imagen)
    if (file) {
      formData.append('image', file);
      // formData.append('perfil', perfil);
    }
    return this.http.post(URL_SERVICIOS + '/postCrudImgProfileCustomer/' + id, formData, httpOptions).toPromise();

    /** Imagen Customer profile Background  */
  }
}